import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const OnboardingOffboarding: Illustration = (props) => (
  <svg viewBox="0 0 154 85" {...illustrationProps(props, { width: 154 })}>
    <g fill="#bec4ff">
      <path d="M35.111 8a8 8 0 0 1 8-8h59.778a8 8 0 0 1 8 8v35.333a8 8 0 0 1-8 8H35.111z" />
      <path d="M52.222 24.445v26.888h-28.44c-1.899 0-2.728-2.399-1.235-3.572z" />
      <path d="M121.889 41a8 8 0 0 0-8-8H54.111a8 8 0 0 0-8 8v35.333a8 8 0 0 0 8 8h67.778z" />
    </g>
    <path
      d="M110.889 33H54.111a8 8 0 0 0-8 8v10.333h56.778a8 8 0 0 0 8-8z"
      fill="#97a1ff"
    />
    <path
      d="M104.778 57.444v26.89h28.439c1.9 0 2.73-2.4 1.236-3.573z"
      fill="#bec4ff"
    />
    <path
      clipRule="evenodd"
      d="M11.25 11.429c-.257-.703-.994-1.08-1.646-.842-.652.238-.973 1.001-.716 1.705l1.667 4.566-5.128-2.624a1.194 1.194 0 0 0-1.67.61 1.43 1.43 0 0 0 .657 1.8l5.128 2.625-5.022 1.834c-.653.238-.973 1.001-.717 1.704.257.704.994 1.08 1.647.843l4.235-1.547-1.754 4.175c-.28.666.015 1.472.657 1.801.643.33 1.391.056 1.67-.61l2.232-5.31 1.977 5.415c.257.703.994 1.08 1.646.842.653-.238.973-1.001.717-1.705l-1.668-4.566 3.775 1.931c.642.329 1.39.056 1.67-.61a1.432 1.432 0 0 0-.658-1.8l-3.774-1.932 4.235-1.546c.653-.239.973-1.002.716-1.705-.256-.703-.993-1.08-1.646-.842l-5.022 1.833 2.12-5.045c.279-.666-.015-1.472-.658-1.801s-1.391-.056-1.67.61l-1.643 3.909z"
      fill="#b8e682"
      fillRule="evenodd"
    />
    <path
      d="M143.147 35.516a81.863 81.863 0 0 1-1.922-3.736c-.403-.851-.105-1.804.712-2.276.77-.444 1.892-.085 2.275.712a82.236 82.236 0 0 0 1.899 3.692 85.188 85.188 0 0 1 3.908-2.015c.85-.403 1.803-.104 2.275.712.444.77.085 1.892-.712 2.275a85.297 85.297 0 0 0-3.864 1.992 87.36 87.36 0 0 0 2.179 3.821c.488.802.035 1.846-.712 2.276-.824.48-1.815.036-2.275-.712a81.651 81.651 0 0 1-2.156-3.777 84.295 84.295 0 0 0-3.649 2.085c-.802.488-1.845.035-2.276-.712-.479-.824-.036-1.815.712-2.275a79.554 79.554 0 0 1 3.606-2.062z"
      fill="#97a1ff"
    />
    <path
      d="M27.955 67.547c-.13-.838-.57-1.642-1.229-2.102-.633-.44-1.508-.502-2.234-.406-.471.062-.88.193-1.26.515-.291.248-.496.591-.626.97-.348.15-.559.5-.596.948-.068.797.217 1.6.689 2.205.18.357.422.653.77.838a3.8 3.8 0 0 0 1.166.392c.857.144 1.874.206 2.57-.474.272-.268.409-.612.452-.983.05-.082.093-.165.13-.247.224-.536.255-1.079.168-1.656zm-3.283.227s.013-.014 0 0z"
      fill="#bec4ff"
    />
  </svg>
);
